package io.eqoty.secretk.types.proto

/***
 * Reference:
 * https://github.com/scrtlabs/SecretNetwork/blob/master/proto/secret/compute/v1beta1/msg.proto
 */
@kotlinx.serialization.Serializable
class MsgUpdateAdminResponseProto : MsgProto()